import initialState from '../../../redux/reducers/initial-state';
import actionTypes from '../../../redux/actions/action-types';

const teamMembersPageReducer = (state = initialState.teamMembersPage, action) => {
  switch (action.type) {
    case actionTypes.teamMembersPage.set:
      return {
        ...state,
        ...action.data,
      };
  }
  return state;
};

export default teamMembersPageReducer;
